<template>
  <div class="layout">
    <head-top-bar></head-top-bar>
    <!-- <head-tab-bar></head-tab-bar> -->
    <router-view></router-view>
    <footer-index></footer-index>
  </div>
</template>
<script>
import HeadTopBar from '@/views/layout/HeadTopBar'
// import HeadTabBar from '@/views/layout/HeadTabBar'
import FooterIndex from '@/views/layout/FooterIndex'
export default {
  components: { HeadTopBar, FooterIndex }
}
</script>
<style lang="stylus" scoped>
</style>
